import React from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ValidatorComponent } from 'react-form-validator-core'; // Import ValidatorComponent

class CommonDatePicker extends ValidatorComponent {
    constructor(props) {
        super(props);

        this.state = {
            isPickerOpen: false,
        };
    }
    render() {
        const { ...rest } = this.props;
        const { isPickerOpen } = this.state
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div onClick={this.handleInputFocus} >
                    <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        format="M/d/yyyy"
                        {...rest}
                        value={this.props.value || ''}
                        onChange={this.handleDateChange}
                        open={isPickerOpen || ''}
                        onClose={this.handlePickerClose}
                        InputAdornmentProps={{ position: 'start' }}
                        invalidDateMessage={''}
                    />
                </div>
                {this.errorText()}
            </MuiPickersUtilsProvider>
        );
    }

    handleDateChange = (date) => {
        if (this.props.onChange) {
            this.props.onChange(date, this.props.name);
        }

        this.validate(date);
    }

    handleInputFocus = () => {
        this.setState({ isPickerOpen: true });
    }

    handlePickerClose = () => {
        setTimeout(() => {
            this.setState({ isPickerOpen: false });
        }, 100)
    }

    errorText() {
        const { isValid } = this.state;

        if (isValid) {
            return null;
        }

        return (
            <div className="error">
                {this.getErrorMessage()}
            </div>
        );
    }
}

export default CommonDatePicker;
